import { Component } from 'react'
import * as styles from 'styles/molecules/forms/OnboardingForm.css'
import PropertyFormContainer from 'components/features/pfm/PropertyForm/PropertyFormContainer'
import GatherHeader from 'components/features/pfm/GatherHeader/GatherHeader'
import Onboarding from 'components/pages/Onboarding'
import Anchor from 'components/atoms/navigation/Anchor'
import { ONBOARDING_PROPERTY } from 'constants/pages'
import NavigationRedirect from 'components/atoms/navigation/NavigationRedirect'
import { ONBOARDING_STEP_NUMBERS, STEPS_COUNT_WITH_FORM } from 'constants/onboarding'

export type OnboardingPropertyStateProps = {
  firstName: string | null
  isBlocked: boolean
}

type OnboardingPropertyProps = OnboardingPropertyStateProps

const STEP_NUMBER = ONBOARDING_STEP_NUMBERS['property']
class OnboardingProperty extends Component<OnboardingPropertyProps> {

  render () {
    const { isBlocked } = this.props

    if (isBlocked) {
      return (
        <NavigationRedirect to='home' />
      )
    }

    return (
      <Anchor placement={ ONBOARDING_PROPERTY }>
        <Onboarding progressPercent={ 66 }>
          <GatherHeader
            title='Now let’s find your peers'
            step={ STEP_NUMBER }
            maxStep={ STEPS_COUNT_WITH_FORM }
          >
            This information allows us to accurately create your peer group
            so you can anonymously compare yourself with people like you.
          </GatherHeader>
          <section className={ styles.onboardingFormWrapper }>
            <PropertyFormContainer />
          </section>
        </Onboarding>
      </Anchor>
    )
  }
}

export default OnboardingProperty
